<template>
  <div class="form">
    <h5 class="c-config-content__title">{{ $t('campaignSetting') }}</h5>
    <div v-if="firstLoading">
    </div>
    <div v-else>
      <b-form-group v-if='formModel.id' :label="$t('getId')">
        <b-input-group>
          <b-form-input v-model="formModel.id" :readonly="true"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="getId(formModel.id)">{{ $t('clone') }}</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <form-input :disabled="true" :error-only="true" :label="$t('callCampaignName')"
                  :model="formModel" attribute="name"
                  :errors="formErrors"></form-input>


      <form-radio-group :disabled="true" :error-only="true" :label="$t('messageType')"
                        :model="formModel" attribute="type"
                        :errors="formErrors" @change="typeChange"
                        :options="typeOptions"></form-radio-group>

      <div class="row" v-if="formModel.type !== 'sms'">
        <div class="col-md">
          <form-checkbox :chk-label="$t('isAgainTwo')" :model="formModel" attribute="isAgainTwo" :errors="formErrors" :disabled="true"></form-checkbox>
        </div>
        <div class="col-md" v-if="formModel.isAgainTwo">
          <form-radio-group :disabled="true" :error-only="true" :label="$t('messageTypeTwo')"
                            :model="formModel" attribute="typeTwo"  @change="typeTwoChange" :errors="formErrors" :options="typeTwoOptions"></form-radio-group>
        </div>
      </div>
      <div v-if="formModel.type !== 'sms' && formModel.typeTwo !== 'sms' && formModel.isAgainTwo && formModel.typeTwo" class="row">
        <div class="col-md">
          <form-checkbox :disabled="true" :chk-label="$t('isAgainThree')" :model="formModel" attribute="isAgainThree" :errors="formErrors"></form-checkbox>
        </div>
        <div class="col-md" v-if="formModel.isAgainThree">
          <form-radio-group :disabled="true" :error-only="true" :label="$t('messageTypeThree')"
                            :model="formModel" attribute="typeThree" :errors="formErrors"  :options="typeThreeOptions"></form-radio-group>
        </div>
      </div>

      <fieldset class="scheduler-border" v-if="formModel.type === 'sms' || (formModel.isAgainTwo && formModel.typeTwo === 'sms') || (formModel.isAgainThree && formModel.typeThree === 'sms')">
        <legend class="scheduler-border">{{$t("sms")}}</legend>
        <div class="form-horizontal">
          <form-radio-group :disabled="true" :label="$t('smsType')"
                            :model="formModel" attribute="smsType" :errors="formErrors" @change="smsTypeChange"
                            :options="smsTypeOptions"></form-radio-group>
          <form-select v-if="formModel.smsType" :label="$t('brandName')" :disabled="true" :full-width="true" :model="formModel"
                       attribute="smsBrandName" @change="smsBrandNameChange" :options="smsBrandNameOptions"
                       :errors="formErrors"></form-select>
          <form-select v-if="formModel.smsType === 'care'" :label="$t('smsTemplate')" :model="formModel"
                       :disabled="true" :full-width="true" @change="smsTemplateChange"
                       attribute="smsTemplate" :errors="formErrors" :options="smsTemplateOptions">
          </form-select>
          <div v-if="formModel.smsType === 'care' && formModel.smsTemplate && smsTemplate" class="alert alert-info"
               v-html="smsTemplate.content"></div>
        </div>
      </fieldset>
      <fieldset class="scheduler-border" v-if="formModel.type === 'zns' || (formModel.isAgainTwo && formModel.typeTwo === 'zns') || (formModel.isAgainThree && formModel.typeThree === 'zns')">
        <legend class="scheduler-border">{{$t("zns")}}</legend>
        <form-select :label="$t('template')" :disabled="true" :model="formModel"
                     @change="znsTemplateChange" :full-width="true"
                     attribute="znsTemplate" :errors="formErrors" :show-desc="true"
                     :options="znsTemplateOptions"></form-select>
        <div v-if="znsTemplate" class="alert alert-info" v-html="znsTemplate.desc"></div>
      </fieldset>
      <fieldset class="scheduler-border" v-if="formModel.type === 'viber' || (formModel.isAgainTwo && formModel.typeTwo === 'viber') || (formModel.isAgainThree && formModel.typeThree === 'viber')">
        <legend class="scheduler-border">{{$t("viber")}}</legend>
        <form-select :label="$t('brandName')" :disabled="true" :model="formModel"
                     :errors="formErrors" :full-width="true"
                     attribute="viberBrandName" :options="viberBrandNameOptions"></form-select>
      </fieldset>
    </div>
  </div>
</template>

<style>
fieldset.scheduler-border {
  border: 1px groove #f5f5f5 !important;
  padding: 0 1.4em 1.4em 1.4em !important;
  margin: 0 0 1.5em 0 !important;
  -webkit-box-shadow:  0 0 0 0 #f5f5f5;
  box-shadow:  0 0 0 0 #f5f5f5;
}

legend.scheduler-border {
  font-size: 1.2em !important;
  font-weight: bold !important;
  text-align: left !important;
  width:auto;
  padding:0 10px;
  border-bottom:none;
}
</style>

<script>
import CRUD from "@/mixins/CRUD";

export default {
  name: "Info",
  props: ['campaign', 'updatePermission'],
  mixins: [CRUD],
  components: {},
  data() {
    return {
      firstLoading: false,
      service: '/message-campaign',
      smsTypeOptions: [
        // {value: null, text: this.$t('chooseSMSType')},
        {value: 'ads', text: this.$t('ads')},
        {value: 'care', text: this.$t('care')},
      ],
      smsBrandNames: [],
      smsBrandNameOptions: [{value: null, text: this.$t('chooseBrandName')}],
      smsTemplates: [],
      smsTemplateOptions: [{value: null, text: this.$t('chooseTemplate')}],
      viberBrandNames: [],
      viberBrandNameOptions: [{value: null, text: this.$t('chooseBrandName')}],
      znsTemplates: [],
      znsTemplateOptions: [{value: null, text: this.$t('chooseTemplate')}],
      defaultFormModel: {
        name: null,
        type: "sms",
        smsType: "care",
        smsBrandName: null,
        smsTemplate: null,
        viberBrandName: null,
        znsTemplate: null,
        setTimer: false,
        scheduledSendTime: null,
        isAgainTwo: false,
        typeTwo: null,
        isAgainThree: false,
        typeThree: null
      },
      smsTemplate: null,
      znsTemplate: null,
      typeTwoOptions: [],
      typeThreeOptions: [],
    }
  },

  computed: {
    typeOptions() {
      let options = [
        {value: 'sms', text: this.$t('sms')},
      ];
      options.push({value: 'viber', text: this.$t('viber')});
      options.push({value: 'zns', text: this.$t('zns')},);
      return options;
    }
  },
  methods: {
    typeChange() {
      setTimeout(() => {
        this.formModel.isAgainTwo = false;
        this.formModel.isAgainThree = false;
        this.formModel.typeTwo = null;
        this.typeTwoOptions = this.typeOptions.filter(option => option.value !== this.formModel.type);
        this.typeThreeOptions = [];
      }, 300);
    },
    typeTwoChange() {
      setTimeout(() => {
        this.formModel.smsType = 'care';
        this.formModel.isAgainThree = false;
        this.typeThreeOptions = this.typeTwoOptions.filter(option => option.value !== this.formModel.typeTwo);
        if (this.typeThreeOptions && this.typeThreeOptions.length === 1) {
          this.formModel.typeThree = this.typeThreeOptions[0].value;
        }
      }, 300);
    },
    znsTemplateChange() {
      this.znsTemplate = this.znsTemplates.find(o => o._id === this.formModel.znsTemplate);
    },
    smsTemplateChange() {
      this.smsTemplate = this.smsTemplates.find(o => o._id === this.formModel.smsTemplate);
    },
    smsTypeChange(useBrandName) {
      setTimeout(() => {
        let options = [{value: null, text: this.$t('chooseBrandName')}];
        this.smsBrandNames.forEach(t => {
          if(!this.formModel.smsType || (this.formModel.smsType === 'care' && t.care === true) || (this.formModel.smsType === 'ads' && t.ads === true)) {
            options.push({value: t._id, text: t.name});
          }
        });
        this.smsBrandNameOptions = options;
        if(!useBrandName) {
          this.formModel.smsBrandName = null;
          this.formModel.smsTemplate = null;
        }
      }, 200);
    },
    smsBrandNameChange(useTempate) {
      let options = [{value: null, text: this.$t('chooseTemplate')}];
      if (this.formModel.smsBrandName) {
        this.smsTemplates.forEach(t => {
          if (t.brandName === this.formModel.smsBrandName) {
            options.push({value: t._id, text: t.name});
          }
        });
      }
      this.smsTemplateOptions = options;
      if(!useTempate) {
        this.formModel.smsTemplate = null;
        this.smsTemplate = null;
      }
    },
    getId(str) {
      this.$copyText(str).then(() => {
        this.$swal({
          text: this.$t('idCopied'),
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      }, () => {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('copyFailed'),
          icon: 'error'
        });
      })
    },
    saveNext() {
      this.save().then(data => {
        if (data) {
          this.$emit('next', 'contactFields', data);
        }
      });
    }
  },
  async mounted() {
    let loader = this.$loading.show();
    let parmas = {
      page: 1,
      pageSize: 500,
      status: 'activated',
      client: this.campaign.client._id
    }
    let response = await this.$service.get("/viber-brand-name", {
      params: parmas
    });
    this.viberBrandNames = response.data.docs;
    let options = [{value: null, text: this.$t('chooseBrandName')}];
    this.viberBrandNames.forEach(t => {
      options.push({value: t._id, text: t.name});
    });
    this.viberBrandNameOptions = options;

    response = await this.$service.get("/sms-brand-name", {params: parmas});
    this.smsBrandNames = response.data.docs;
    options = [{value: null, text: this.$t('chooseBrandName')}];
    this.smsBrandNames.forEach(t => {
      options.push({value: t._id, text: t.name});
    });
    this.smsBrandNameOptions = options;

    response = await this.$service.get("/sms-template", {params: parmas});
    this.smsTemplates = response.data.docs;

    response = await this.$service.get("/zns-template", {params: parmas});
    this.znsTemplates = response.data.docs;
    options = [{value: null, text: this.$t('chooseTemplate')}];
    this.znsTemplates.forEach(t => {
      options.push({value: t._id, text: t.name});
    });
    this.znsTemplateOptions = options;

    this.formModel = {};
    this.formModel = Object.assign({}, this.defaultFormModel);
    this.formErrors = [];
    if (this.campaign) {
      response = await this.$service.get(`${this.service}/${this.campaign._id}`);
      this.formModel = response.data;
      this.formModel.id = this.formModel._id;
      this.typeTwoOptions = this.typeOptions.filter(option => option.value !== this.formModel.type);
      this.typeThreeOptions = this.typeTwoOptions.filter(option => option.value !== this.formModel.typeTwo);

      if (this.formModel.type === 'sms' || (this.formModel.isAgainTwo && this.formModel.typeTwo === 'sms') || (this.formModel.isAgainThree && this.formModel.typeThree === 'sms')) {
        this.smsTypeChange(true);
        this.smsBrandNameChange(true);
        this.smsTemplateChange();
      }
      if (this.formModel.type === 'zns' || (this.formModel.isAgainTwo && this.formModel.typeTwo === 'zns') || (this.formModel.isAgainThree && this.formModel.typeThree === 'zns')) {
        this.znsTemplateChange();
      }
    } else if (this.formModel.type === 'sms') {
      this.smsTypeChange();
    }
    loader.hide();
  },
  i18n: {
    messages: {
      vi: {
        campaignSetting: "Cài đặt chiến dịch",
        getId: "Mã chiến dịch",
        callCampaignName: "Tên chiến dịch",
        messageType: "Loại tin nhắn",
        sms: "SMS",
        viber: "Viber",
        zns: "Zalo ZNS",
        isAgainTwo: "Gửi lại khi gửi thất bại lần 1",
        messageTypeTwo: "Loại tin nhắn gửi lần 2",
        template: "Mẫu tin nhắn",
        clone: "Sao chép",
        smsType: "Loại tin nhắn SMS",
        ads: "Quảng cáo",
        care: "CSKH",
        brandName: "Brand name",
        smsTemplate: "Mẫu SMS",
        chooseBrandName: "Chọn brand name",
        chooseTemplate: "Chọn mẫu",
        isAgainThree: "Gửi lại khi gửi thất bại lần 2",
        messageTypeThree: "Loại tin nhắn gửi lần 3"
      },
      en: {
        campaignSetting: "Cài đặt chiến dịch",
        getId: "Mã chiến dịch",
        callCampaignName: "Tên chiến dịch",
        messageType: "Loại tin nhắn",
        sms: "SMS",
        viber: "Viber",
        zns: "Zalo ZNS",
        isAgainTwo: "Gửi lại khi gửi thất bại lần 1",
        messageTypeTwo: "Loại tin nhắn gửi lần 2",
        template: "Mẫu tin nhắn",
        clone: "Sao chép",
        smsType: "Loại tin nhắn SMS",
        ads: "Quảng cáo",
        care: "CSKH",
        brandName: "Brand name",
        smsTemplate: "Mẫu SMS",
        chooseBrandName: "Chọn brand name",
        chooseTemplate: "Chọn mẫu",
        isAgainThree: "Gửi lại khi gửi thất bại lần 2",
        messageTypeThree: "Loại tin nhắn gửi lần 3"
      }
    }
  }
}
</script>
